import { Pipe, PipeTransform, Inject, LOCALE_ID, Injector } from '@angular/core';
//import { DatePipe } from '@angular/common';


@Pipe({
    name: "search",
    pure: false
})
export class SearchPipe implements PipeTransform {
    transform(term: any, args: any[]) {
        if (term == null) {
            return null;
        }
        return args.filter((item) => {
            return  item.Name.includes(term) 
        });

    }


}


// WEBPACK FOOTER //
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/common/pipe/search.pipe.ts